import { useOutletContext } from "react-router";

export type RightRenderer = React.ReactNode;
export type LayoutCtx = { setRight: (c: RightRenderer) => void };

export function useRightPanel() {
  return useOutletContext<LayoutCtx>();
}
